import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Row,
  FormCheckbox,
} from "shards-react";
import { strings } from "../../localization";
import PageTitle from "../../components/common/PageTitle";
import { Link } from "react-router-dom";
import { API_URL, getOrganisationName, isRestaurantSelfServiceEnabled, Language } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";

const customStyles = {
  control: (provided) => ({
    ...provided,
    marginBottom: "15px",
    fontSize: "14px",
  }),
};

export default class EditRestaurantTable extends Component {
  constructor(props) {
    super(props);
    strings.setLanguage(Language);
    this.state = {
      name: "",
      loader: "",
      id: "",
      isButtonDisabled: false,
      spaces: [],
      selectedSpace: null,
      isSelfService: false,
      qrCodeData: null,
      isGeneratingQR: false,
      qrCodeUrl: "",
      isSelfServiceEnabled: false
    };
  }

  // added by shivraj on 2025-11-27
  // Get organization self-service status from localStorage
  getOrgSelfServiceStatus = () => {
    try {
      const orgInfo = localStorage.getItem("organisation_info");
      if (orgInfo) {
        const parsedOrgInfo = JSON.parse(orgInfo);
        const isSelfServiceEnabled = (parsedOrgInfo && parsedOrgInfo.data && parsedOrgInfo.data.isSelfServiceEnabled) || false;
        this.setState({ orgIsSelfServiceEnabled: isSelfServiceEnabled });
        return isSelfServiceEnabled;
      }
    } catch (error) {
      console.warn("Error parsing organisation_info from localStorage:", error);
    }
    return false;
  };

  // This function is used to call restaurant table create or update api
  handleSaveButtonClick = () => {
    if (
      this.state.name === undefined ||
      this.state.name === null ||
      this.state.name === ""
    ) {
      toast.error(strings.fill_fields, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({
        loader: "fa fa-spinner fa-spin",
        isButtonDisabled: true,
      });
      let selectedSpaceId = "";
      if (this.state.selectedSpace) {
        selectedSpaceId = this.state.selectedSpace.value;
      }
      console.log("selectedSpaceId", selectedSpaceId);
      let string = {
        tableName: this.state.name,
        isSelfService: this.state.isSelfService,
      };

      if (selectedSpaceId !== "") {
        string["restaurantSpaceID"] = selectedSpaceId;
      }
      console.log("body data for restaurant table", string);

      fetch(`${API_URL}restaurant-table${this.state.id}`, {
        method: this.state.id ? "put" : "post",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(string),
      })
        .then((res) => {
          if (res.status == 200) {
            toast.success(strings.successfully_created, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

            this.setState({ loader: "", isButtonDisabled: false });
          }
          return res.json();
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    }
  };

  // Generate QR Code function
  generateQRCode = () => {
    this.setState({ isGeneratingQR: true });
    const tableId = this.props.match.params.id;
    const bodyData = {
      restaurantTableID: tableId,
      useSelfService: this.state.isSelfService,
    };
    console.log("🚀 ~ EditRestaurantTable ~ bodyData:", bodyData);
    let statusCode = 0;
    fetch(`${API_URL}restaurant-table/qr`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    })
      .then((res) => {
        statusCode = res.status;
        return res.json();
      })
      .then((res) => {
        if (statusCode === 200) {
          const data = res.data || "";
          if (data) {
            let qrCode = ""
            if (data.base64QR) {
              qrCode = `data:image/png;base64,${data.base64QR}`
            }
            this.setState({
              qrCodeData: qrCode,
              qrCodeUrl: data.qrLink,
            });
            toast.success(strings.qr_code_success_msg, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          this.setState({
            isGeneratingQR: false,
          });
        } else {
          toast.error(res.message || strings.qr_code_error_msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.setState({ isGeneratingQR: false });
        }
      })
      .catch((err) => {
        console.warn(err);
        toast.error(strings.qr_code_error_msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.setState({ isGeneratingQR: false });
      });
  };

  // Copy URL to clipboard
  copyUrlToClipboard = () => {
    navigator.clipboard
      .writeText(this.state.qrCodeUrl)
      .then(() => {
        toast.success(strings.url_copied_success_msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch(() => {
        toast.error(strings.url_copied_error_msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  // Download QR Code
  downloadQRCode = () => {
    if (this.state.qrCodeData) {
      const link = document.createElement("a");
      link.href = this.state.qrCodeData;
      link.download = `qr-code-table-${this.state.id.replace("/", "")}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // This function is used to call restaurant space get api
  getSpaceData = () => {
    fetch(`${API_URL}restaurant-space`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("response of restaurant space", res);
        const result = res.result;
        if (result && result.length > 0) {
          let spaceList = [];
          result.map((item) => {
            spaceList.push({
              label: item.data.spaceName,
              value: item._id,
            });
          });
          this.setState({
            spaces: spaceList,
          });
        }
      })
      .catch((err) => {
        console.log("catch block error at getting bar list", err);
      });
  };

  getQRCodeDetailsOfTable = () => {
    const tableId = this.props.match.params.id;
    fetch(`${API_URL}restaurant-table/qr/${tableId}`, {
      method: "get",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        console.log("response of web config get api", res);
        if (res.status == 200) {
          const parsedData = await res.json();
          console.log("parsedData of web config", parsedData);
          console.log("parsedData of web config if condition", parsedData);
          const data = parsedData["data"];
          let base64QR = "";
          if (data.base64QR) {
            base64QR = `data:image/png;base64,${data.base64QR}`
          }
          this.setState({
            qrCodeData: base64QR,
            qrCodeUrl: data["qrLink"] || "",
            isSelfService: true,
          });
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  // This method is used to call restaurant table detail api
  componentDidMount() {
    this.getSpaceData();
    const orgIsSelfServiceEnabled = this.getOrgSelfServiceStatus();

    if (this.props.match.params.id) {
      fetch(`${API_URL}restaurant-table/${this.props.match.params.id}`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then(({ data }) => {
          this.getQRCodeDetailsOfTable();
          let restaurantSpaceID = data.restaurantSpaceID;
          let spaceId = restaurantSpaceID
            ? {
                label: restaurantSpaceID.spaceName,
                value: restaurantSpaceID.restaurantSpaceID,
              }
            : "";
          this.setState({
            name: data.tableName,
            selectedSpace: spaceId,
            id: "/" + this.props.match.params.id,
          });

          // added by shivraj on 2025-11-27
          // Auto-generate QR code if org has self-service enabled
          if (orgIsSelfServiceEnabled) {
            this.getQRCodeDetailsOfTable();
            // If no QR code exists, generate one
            setTimeout(() => {
              if (!this.state.qrCodeData) {
                this.generateQRCode();
              }
            }, 500);
          }
        });
    }
    const selfServiceStatus = isRestaurantSelfServiceEnabled()
    this.setState({
      isSelfServiceEnabled: selfServiceStatus
    })
  }

  render() {
    const {
      name,
      isSelfService,
      qrCodeData,
      isGeneratingQR,
      qrCodeUrl,
      orgIsSelfServiceEnabled,
    } = this.state;
    return (
      <div>
        <Container
          fluid
          className="main-content-container px-4"
          style={{ marginBottom: "200px" }}
        >
          <Row noGutters className="page-header py-4">
            <PageTitle
              title={
                this.props.match.params.id
                  ? strings.edit_table
                  : strings.create_table
              }
              subtitle={strings.overview}
              md="12"
              className="ml-sm-auto mr-sm-auto"
            />
          </Row>
          <Row>
            <Col lg="6" md="10" sm="12">
              <Card small className="mb-4">
                <CardHeader className="border-bottom">
                  <h6 className="m-0">
                    {this.props.match.params.id
                      ? strings.edit_table
                      : strings.create_table}
                  </h6>
                </CardHeader>
                <ListGroup flush>
                  <ListGroupItem className="p-3">
                    <Row>
                      <Col>
                        <Form id="TableForm">
                          <label htmlFor="code">{strings.table_name}</label>
                          <InputGroup seamless className="mb-3">
                            <InputGroupAddon type="prepend">
                              <InputGroupText>
                                <i className="material-icons">dashboard</i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <FormInput
                              type="text"
                              id="code"
                              value={name}
                              placeholder={strings.table_name}
                              onChange={(e) =>
                                this.setState({ name: e.target.value })
                              }
                            />
                          </InputGroup>
                          <Select
                            options={this.state.spaces}
                            onChange={(e) => {
                              console.log("event", e);
                              const selectedValue = e;
                              if (selectedValue) {
                                this.setState({
                                  selectedSpace: e,
                                });
                              } else {
                                this.setState({
                                  selectedSpace: "",
                                });
                              }
                            }}
                            placeholder={strings.select_space}
                            value={this.state.selectedSpace}
                            styles={customStyles}
                          />
                          {/* {this.props.match.params.id && this.state.isSelfServiceEnabled && (
                            <FormCheckbox
                              className="mb-3"
                              checked={isSelfService}
                              onChange={(e) =>
                                this.setState({
                                  isSelfService: e.target.checked,
                                })
                              }
                            >
                              {strings.use_table_for_self_service}
                            </FormCheckbox>
                          )} */}
                          <ToastContainer />
                          <Button
                            theme="accent"
                            onClick={() => this.handleSaveButtonClick()}
                            disabled={this.state.isButtonDisabled}
                          >
                            <i
                              className={this.state.loader}
                              style={{ fontSize: "15px" }}
                            ></i>{" "}
                            {strings.save}
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </ListGroup>
              </Card>
            </Col>
            {this.props.match.params.id && orgIsSelfServiceEnabled && (
              <Col lg="6" md="12" sm="12">
                <Card small className="mb-4">
                  <CardHeader className="border-bottom">
                    <h6 className="m-0">{strings.qr_code_generation}</h6>
                  </CardHeader>
                  <ListGroup flush>
                    <ListGroupItem className="p-3">
                      {!qrCodeData ? (
                        <Button
                          theme="primary"
                          onClick={this.generateQRCode}
                          disabled={isGeneratingQR}
                          className="w-100"
                        >
                          {isGeneratingQR ? (
                            <>
                              <i
                                className="fa fa-spinner fa-spin"
                                style={{ fontSize: "15px" }}
                              ></i>{" "}
                              {strings.generating_qr_code}...
                            </>
                          ) : (
                            "Generate QR Code"
                          )}
                        </Button>
                      ) : (
                        <div className="text-center">
                          <div className="mb-3">
                            <img
                              src={qrCodeData}
                              alt="QR Code"
                              style={{ maxWidth: "200px", height: "auto" }}
                              className="img-fluid"
                            />
                          </div>
                          <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                              <a
                                href={qrCodeUrl}
                                className="text-truncate mr-2"
                                style={{ fontSize: "12px", cursor: "pointer" }}
                              >
                                {qrCodeUrl}
                              </a>
                              <Button
                                size="sm"
                                theme="light"
                                onClick={this.copyUrlToClipboard}
                              >
                                <i
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  content_copy
                                </i>
                              </Button>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <Button
                              theme="primary"
                              onClick={this.downloadQRCode}
                              className="flex-fill"
                            >
                              <i
                                className="material-icons"
                                style={{ fontSize: "16px" }}
                              >
                                download
                              </i>{" "}
                              {strings.download_qr_codde}
                            </Button>
                            {/* <Button
                                theme="light"
                                onClick={() => this.setState({ qrCodeData: null, qrCodeUrl: "" })}
                                className="flex-fill"
                            >
                                <i className="material-icons" style={{ fontSize: '16px' }}>refresh</i>{" "}
                                Regenerate
                            </Button> */}
                          </div>
                        </div>
                      )}
                    </ListGroupItem>
                  </ListGroup>
                </Card>
              </Col>
            )}
            <Col>
              <Link to={"/tables"} className="float-left">
                <Button
                  id="go_back"
                  theme="light"
                  className="mb-2 mr-1"
                  style={{
                    marginTop: "-84px",
                    position: "relative",
                    left: "-100px",
                  }}
                >
                  {strings.go_back}
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
